import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsTrackerService {
  public documentTitle: string;

  public categoryForEvents: string;

  constructor(private location: Location) {
    // [TRACKING DISABLED] this.enableHeartBeatTimer();
  }

  public init() {
    // [TRACKING DISABLED]
    // if (environment.production && !this.isLoaded()) {
    //   this.matomoTrackerService.init(
    //     environment.analytics.trackerUrl,
    //     environment.analytics.siteId,
    //     environment.analytics.subdomain
    //   );
    // }
  }

  public trackEvent(_action: string, _name?: string, _category?: string): void {
    // [TRACKING DISABLED] this.matomoTrackerService.trackEvent(category || this.categoryForEvents, action, name, null);
  }

  public trackEventError(
    _action: string,
    _errorTitle: any,
    _isApiError: boolean = true,
    _category?: string
  ): void {
    // [TRACKING DISABLED]
    // this.matomoTrackerService.trackEvent(
    //   category || this.categoryForEvents,
    //   action,
    //   isApiError ? `Api Error: ${errorTitle}` : errorTitle
    // );
  }

  public initPageInfo(customTitleArray: string[], categoryForEvents: string): void {
    this.setDocumentTitle(customTitleArray);
    this.setCategoryForEvents(categoryForEvents);
    this.setCustomUrl(this.location.prepareExternalUrl(this.location.path()));
  }

  public setCategoryForEvents(category: string) {
    this.categoryForEvents = category;
  }

  public initPageTracking(customTitleArray: string[], categoryForEvents: string): void {
    this.initPageInfo(customTitleArray, categoryForEvents);
    this.trackPageView();
  }

  public trackPageView(_customTitleArray?: string[]): void {
    // [TRACKING DISABLED]
    // this.matomoTrackerService.trackPageView(
    //   customTitleArray && customTitleArray[0] !== undefined ? customTitleArray.join(' / ') : null
    // );
  }

  public setDocumentTitle(customTitleArray: string[]) {
    this.documentTitle = customTitleArray.join(' / ');
    // [TRACKING DISABLED] this.matomoTrackerService.setDocumentTitle(this.documentTitle);
  }

  public enableHeartBeatTimer(_customInterval?: number): void {
    // [TRACKING DISABLED] this.matomoTrackerService.enableHeartBeatTimer(customInterval);
  }

  public setUserId(_userId: string): void {
    // [TRACKING DISABLED] this.matomoTrackerService.setUserId(userId);
  }

  public resetUserId() {
    // [TRACKING DISABLED] this.matomoTrackerService.resetUserId();
  }

  public setCustomUrl(_customUrl: string) {
    // [TRACKING DISABLED] this.matomoTrackerService.setCustomUrl(customUrl);
  }

  public isLoaded() {
    // [TRACKING DISABLED] return !!this.matomoTrackerService.getInstance();
    return false;
  }

  public optOutCookies() {
    // [TRACKING DISABLED]
    // this.matomoTrackerService.disableCookies();
    // this.matomoTrackerService.deleteCookies();
  }
}
